<template>
  <transition name="modal">
    <div class="loading-panel">
      <loading-animation />
    </div>
  </transition>
</template>

<script>
import LoadingAnimation from "@/components/LoadingAnimation";

export default {
  name: "LoadingPanel",
  components: {
    LoadingAnimation,
  },
};
</script>

<style lang="scss" scoped>
.loading-panel {
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: $brand-blue;
}

.loading-panel-enter,
.loading-panel-leave-active {
  opacity: 0;
  transform: scale(0.9);
}
</style>
